import { getFeatureConfig } from '@luna/feature-config';
import { getNameInitials } from '@shared/core-ui-avatar';

import type { MyProfile } from '../ProfileTypes';
import { useMyProfile } from '../ProfileService';

export function useProfileInitials(): string {
    const { data: profile } = useMyProfile();
    const { inverseNameOrder } = getFeatureConfig((config) => config.profile);

    return createInitials(profile, inverseNameOrder);
}

function createInitials(
    profile?: Pick<MyProfile, 'firstname' | 'lastname'>,
    reversed?: boolean,
): string {
    if (!profile || !profile.firstname || !profile.lastname) {
        return '';
    }

    const FIRST_NAME_INITIAL = getNameInitials(profile.firstname, 1);
    const LAST_NAME_INITIAL = getNameInitials(profile.lastname, 1);

    if (reversed) {
        return `${LAST_NAME_INITIAL}${FIRST_NAME_INITIAL}`;
    }

    return `${FIRST_NAME_INITIAL}${LAST_NAME_INITIAL}`;
}
